/* eslint-disable no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { ToggleOption } from 'web-ui-components/lib/molecules/toggle';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { TogglePanel } from 'web-ui-components/lib/molecules/panels';
import { getTransactionToggleRequestPacket } from '../../utils/RequestPacketBuilder';
import { CommonModal } from '../common/CommonModal';

const TransactionAbroad = ({
  content,
  handleTransactionToggleRequestPacket,
  isAbroadEnabled,
  getAbroadURL,
  showAbroadPopup,
  isAbroadPopupEnabled,
  closeAbroadPopup,
}) => {
  const {
    abroadTitle,
    abroadTextBody,
    abroadInfoTitle,
    abroadInfoText,
    abroadHyperLinkText,
    abroadPopupHeading,
    abroadPopupConetnt,
    cancelText,
    continueText,
    abroadInforamationText,
  } = content;

  const confirmAbroadToggleChange = () => {
    const transactionAbroadRequestPacket = getTransactionToggleRequestPacket(
      'crossborder',
      !isAbroadEnabled
    );
    handleTransactionToggleRequestPacket(transactionAbroadRequestPacket);
  };

  const toggleOptionFactory = () => {
    const displayIcon = (
      <Icon iconType="AbroadOutlineLarge" className="c-a-button__icon" direction="right" />
    );
    return (
      <ToggleOption
        icon={displayIcon}
        title={abroadTitle}
        popoverOptions={{ content: <p>{abroadInforamationText}</p> }}
        blurb={abroadTextBody}
        active={isAbroadEnabled}
        onChange={confirmAbroadToggleChange}
      />
    );
  };
  const openAbroadPopup = () => {
    closeAbroadPopup();
    window.open(getAbroadURL());
  };
  return (
    <div>
      <Card bordered className="u-component-spacing">
        <TogglePanel
          toggleOptionFactory={toggleOptionFactory}
          active={isAbroadEnabled}
          onChange={confirmAbroadToggleChange}
        >
          <br />
          <Card title={abroadInfoTitle} type="info" bordered>
            {abroadInfoText}
            <a href="javascript:void(0);" onClick={showAbroadPopup}>
              {abroadHyperLinkText}
            </a>
          </Card>
        </TogglePanel>
      </Card>
      {isAbroadPopupEnabled && (
        <CommonModal
          isOpen={isAbroadPopupEnabled}
          onRequestClose={closeAbroadPopup}
          onPrimaryBtnClick={openAbroadPopup}
          header={abroadPopupHeading}
          infoCardContent={abroadPopupConetnt}
          primaryBtnName={continueText}
          secondaryBtnName={cancelText}
        />
      )}
    </div>
  );
};
TransactionAbroad.propTypes = {
  content: PropTypes.shape({}),
  confirmAbroadToggleChange: PropTypes.func,
  handleTransactionToggleRequestPacket: PropTypes.func,
  isAbroadEnabled: PropTypes.bool,
  getAbroadURL: PropTypes.func,
  showAbroadPopup: PropTypes.func,
  isAbroadPopupEnabled: PropTypes.bool,
  closeAbroadPopup: PropTypes.func,
};
export default TransactionAbroad;
